import React from 'react'
import {useLayout} from '../../core/LayoutProvider'
import {ToolbarCreateApp} from './ToolbarCreateApp'

const Toolbar = () => {
  const {config} = useLayout()

  switch (config.toolbar.layout) {
    case 'toolbar1':
      return <ToolbarCreateApp />

    default:
      return <ToolbarCreateApp />
  }
}

export {Toolbar}
